import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const ParsnipLogoHeader: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0,
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontFamily: 'MuseoModerno',
        background: 'linear-gradient(to left, #F39A81, #959BEA)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 600,
        marginRight: '-5px',
      }}
    >
      Picasso
    </Typography>
    <Avatar
      sx={{ width: 113, height: 114, marginX: '-5px' }}
      src="/picasso_parsnip.png"
      alt="Picasso Parsnip"
    />
    <Typography
      variant="h4"
      sx={{
        fontFamily: 'MuseoModerno',
        background: 'linear-gradient(to right, #F39A81, #959BEA)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 600,
        marginLeft: '-8px',
      }}
    >
      Parsnip
    </Typography>
  </Box>
);

export default ParsnipLogoHeader;
